export const MUSCLE_GROUPS = new Map([
  ['upper', { name: 'Upper Body' }],
  ['lower', { name: 'Lower Body' }],
  ['back', { name: 'Back' }],
  ['legs', { name: 'Legs' }],
  ['arms', { name: 'Arms' }],
  ['chest', { name: 'Chest' }],
  ['core', { name: 'Core' }],
])

export const EQUIPMENT = new Map([
  ['barbell', { name: 'Olympic Barbell', weight: 45, inc: 5 }],
  ['std_barbell', { name: 'Standard Barbell', weight: 20, inc: 5 }],
  ['dumbbell', { name: 'Dumbbell', inc: 2.5 }],
  ['ez-bar', { name: 'Ez-Bar', weight: 15, inc: 2.5 }],
  ['machine', { name: 'Machine', inc: 2.5 }],
  ['no-bar', { name: 'No bar', weight: 0, inc: 2.5 }],
  ['smith', { name: 'Smith Machine', weight: 0, inc: 2.5 }],
])

export const PLATE_CALCULATOR_EQUIPMENT = [
  'barbell',
  'std_barbell',
  'ez-bar',
  'no-bar',
  'smith',
]

export const DEFAULT_PROGRESS_INCREMENT = 5.0
export const DEFAULT_REST_SECONDS = 120

export const TRAINING_MAXIMUM_MULTIPLIER = 0.9

export const WEIGHT_SHORT_LABEL = 'lbs'

export const WARMUP_SET_TYPE_CODE = -5
export const NORMAL_SET_TYPE_CODE = 0
export const EXTRA_SET_TYPE_CODE = 5
export const ADHOC_SET_TYPE_CODE = 10
export const DROP_SET_TYPE_CODE = 20

export function isNormalSetType(type: SetType | unknown): boolean {
  return type === NORMAL_SET_TYPE_CODE || type === undefined || type === null
}

export const SET_TYPES = {
  [WARMUP_SET_TYPE_CODE]: 'warmup',
  [NORMAL_SET_TYPE_CODE]: 'normal',
  [EXTRA_SET_TYPE_CODE]: 'extra',
  [ADHOC_SET_TYPE_CODE]: 'adhoc',
  [DROP_SET_TYPE_CODE]: 'drop',
}

export type SetType = keyof typeof SET_TYPES
